import update from 'react-addons-update';
import {
	APPLICATION_INIT_SUCCESS,
	APPLICATION_CLEAR,
	APPLICATION_POST_MAINAGENT_SUCCESS,
	APPLICATION_UPDATE_AGENT_INFO,
	APPLICATION_POST_ERROR,
	APPLICATION_CLEAR_ERROR
} from './action.js';

const initState = {
	action: null,
	agentInfo: null,
	errors: null,
	showSuccessDialog: false
};

export default function applicationReducer(state = initState, action) {
	switch (action.type) {
		case APPLICATION_INIT_SUCCESS:
			let initAgentInfo = {};

				// 組合 主帳號註冊資訊
				initAgentInfo = {
					organizationCode: '',
					preferredCurrency: '',
					preferredLanguage: '',
					title: '',
					firstName: '',
					lastName: '',
					mobilePhone: {
						id: null,
						number: '',
						dialCode: ''
					},
					workPhone: {
						id: null,
						number: '',
						dialCode: ''
					},
					email: '',
					confirmEmail: '',
					address1: '',
					address2: '',
					city: '',
					addressState: 'OTH',
					country: '',
					postalCode: '',
					password: '',
					confirmPassword: '',
				};

			return update(state, {
				agentInfo: { $set: initAgentInfo }
			});
		case APPLICATION_POST_MAINAGENT_SUCCESS:
			return update(state, {
				showSuccessDialog: { $set: true }
			});
		case APPLICATION_UPDATE_AGENT_INFO:
			return update(state, {
				agentInfo: { $set: action.data }
			});
		case APPLICATION_POST_ERROR:
      return update(state, {
        errors: { $set: action.errors }
      });
    case APPLICATION_CLEAR_ERROR:
      return update(state, {
        errors: { $set: initState.errors }
      });
		case APPLICATION_CLEAR:
			return initState;
		default:
			return state;
	}
}